//src/mis/pages/Add.js
import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import { Divider, TextField, useTheme, Drawer, Typography, 
  Button, 
  Grid} from "@mui/material";
import { tokens } from "../../theme";

import Stack from '@mui/material/Stack';
import Select from '@mui/material/Select';
import {
  randomId
} from '@mui/x-data-grid-generator';
import moment from "moment";
import { Description } from "@mui/icons-material";

import Modal from '@mui/material/Modal';
import { CloseRounded } from "@mui/icons-material";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { fetchDepartmentsWithMachines } from "../data/machineList"; // Import the new function
import env from "react-dotenv";

function Item(props) {
  const { sx, ...other } = props;
  return (
    <Box className="outer"
      sx={{
        // bgcolor: (theme) => (theme.palette.mode === 'dark' ? '#101010' : '#f2f0f0'),
        // color: (theme) => (theme.palette.mode === 'dark' ? 'grey.300' : 'grey.800'),
        // border: '3px solid',
        //  borderColor: (theme) =>
        //   theme.palette.mode === 'dark' ? 'grey.800' : 'grey.300',
        // p: 1,
        //  borderRadius: 2,
        fontSize: '0.875rem',
        fontWeight: '500',
        ...sx,
      }}
      {...other}
    />
  );
}
Item.propTypes = {
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([
    PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool]),
    ),
    PropTypes.func,
    PropTypes.object,
  ]),
};


const Add = ({open , onClose, onSuccess}) => {
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [selected, setSelected] = useState({});
  const [adate, setADate] = useState(null);
  const [sdate, setSDate] = useState(null);  
  const [cdate, setCDate] = useState(null);
  const [departments, setDepartments] = useState([]); // Store department list in state
  const [machines, setMachines] = useState({}); // Store machines mapping based on department
   
  const location = useLocation();
  React.useEffect( () => {
    if(location.key == undefined || location.key == null || location.key == 'default'){
      navigate("/");   
    }
  }, [ location ] );


  const [data, setData] = useState({
   
    AssignDate: null,
    WorkType: "",
    WorkSubType: "",   // <-- New field
    MainDesc: "",
    StartDate: null,
    CompleteDate: null,
    Comments: "",
    SlipNo: "",
    Remarks: "",
    AssignedTo : "",
    Department: "",
    Machine:"",
  });
 
  const [record, setRecord] = useState({
    slipNo: "",
  });

  useEffect(() => {
    const fetchDepartmentsAndMachines = async () => {
        const departmentMachineMapping = await fetchDepartmentsWithMachines();
        // console.log("Fetched department and machine mapping:", departmentMachineMapping);
        setDepartments(Object.keys(departmentMachineMapping)); // Set department names
        setMachines(departmentMachineMapping); // Set the entire mapping
    };
    fetchDepartmentsAndMachines();
}, []);

const getWorkSubTypeOptions = (workType) => {
  switch (workType) {
    case "Electrical Maintenance":
      return ["Breakdown", "Preventive", "Mould Breakdown"];
    case "Machine Maintenance":
      return ["Mould Change", "Breakdown", "Preventive", "Mould Breakdown"];
    default:
      return []; // Blank for "New Work" or other types
  }
};

// const handleChange = (e) => {
//   const { name, value } = e.target;
//   setData((prevData) => ({ ...prevData, [name]: value })); // Update the data state

//   if (name === 'Department') {
//       // Reset the selected machine when department changes
//       setData((prevData) => ({ ...prevData, Machine: "" })); // Reset the selected machine
//       // console.log("Selected Department:", value); // Log the selected department
//       // console.log("Machines for Selected Department:", machines[value]); // Log the machines for the selected department
//   }
// };

const handleChange = (e) => {
    const { name, value } = e.target;
    setData((prevData) => ({ ...prevData, [name]: value })); // Update the data state

    if (name === 'Department') {
        // Reset the selected machine when department changes
        setData((prevData) => ({ ...prevData, Machine: "" })); // Reset the selected machine
        // console.log("Selected Department:", value); // Log the selected department
        // console.log("Machines for Selected Department:", machines[value]); // Log the machines for the selected department
    }

    if (name === 'WorkType') {
      const options = getWorkSubTypeOptions(value);
      setData((prevData) => ({
        ...prevData,
        WorkType: value,
        WorkSubType: options.length > 0 ? "" : "" // reset sub type
      }));
      return;
    }
    
};

// console.log("Updated Data State:", data);

  const handleClose = () => {
    onSuccess();   
    
  }

  const handleSubmitOnDB = async (e) => {
    e.preventDefault();
  
    const newErrors = validateForm(data);
    
      record["slipNo"] = data.SlipNo;
      const exists = await getSlipNoFromDB();
      if(exists > 0){
        newErrors.SlipNo = "SlipNo already exists";        
      }      
      setErrors(newErrors);
  
    if (Object.keys(newErrors).length === 0) {

      if(adate !== null){
        data['AssignDate'] = moment(new Date(adate)).format("YYYY-MM-DD").toString()
      }
      if(sdate !== null){
        data['StartDate'] = moment(new Date(sdate)).format("YYYY-MM-DD hh:mm A").toString()
      }
      if(cdate !== null){
        data['CompleteDate'] = moment(new Date(cdate)).format("YYYY-MM-DD hh:mm A").toString()
      }
     try { 
        const res = await fetch(`${process.env.REACT_APP_MISBACKEND_URL}/maintenance`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
          }
        );
        onClose();
        onSuccess();
      } catch (error) {
        console.log(error);
      }
    } else {
        console.log(`Form submission failed
        due to validation errors.`);
    }   
  };

  const getSlipNoFromDB = async () => {
     try { 
        const resSlip = await fetch(
          `${process.env.REACT_APP_MISBACKEND_URL}/maintenanceSlip`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(record),
          }
        );
        const response = await resSlip.json();
        return response.length;
      } catch (error) {
        console.log(error);
      }
    } 


  const validateForm = (data) => {
      const errors = {};
      

      if (data.WorkType.trim() == 'Machine Maintenance' && !data.Machine.trim()) {
          errors.Machine = 'Machine is required if worktype is machine maintenance';
          
      }
      return errors;
  };

  
  function Bar() {
    return (
      <Box
        sx={{
          height: 20,
          backgroundColor: (theme) =>
            theme.palette.mode === 'light'
              ? 'rgba(0, 0, 0, 0)'
              : 'rgb(0, 0, 0, 0)',
        }}
      />
    );
  } 

  const modalStyle1 = {
    maxWidth: 1000,marginLeft:"350px", marginTop:"100px",
      // overflow:'scroll',
    };

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  
  return (open) ? (
    <Drawer
        anchor="right"
        open={open}
        onClose={onClose}
        PaperProps={{
          sx: {
            width: 730,
            padding: 2,
          }
        }}
      >
      <div style={{ width: "100%"}}  >
    
        <form style={{ marginLeft:"5px",marginRight:"5px",marginTop:"5px",
                marginBottom:"5px",
                    p: 2,
                    borderRadius: 1}} onSubmit={handleSubmitOnDB}>
                      
          <Typography variant="h4" align="center" color="#4863A0" gutterBottom>
          Add Maintenance Record
          </Typography>
          <Divider style={{ marginBottom: '20px' }} />    
                  
                  <Box className="outerbox"  sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, 2fr)', gap: 2 ,m:1}}>
                  <Item>
                  <FormControl fullWidth>
                  <label htmlFor="AssignDate" className="form-label">Assign Date*</label>
                 
                    <DatePicker
                      prop
                      disabledKeyboardNavigation
                      required
                      name="AssignDate"
                      selected={adate}          
                      className="customInput"
                      popperProps={{
                        positionFixed: true // use this to make the popper position: fixed
                        
                      }}
                      dateFormat="YYYY-MM-dd"
                      autoComplete="off"        
                      onChange={(adate) => setADate(new Date(adate))}
                    />
                  
                </FormControl>
              </Item>
              <Item>
                <FormControl fullWidth>
                  
                  <label htmlFor="StartDate" className="form-label">Start Date</label>
                  {/* <TextField size="small"  type="datetime"   name="StartDate" onChange={handleChange} variant="outlined" />
                  */}
                  <DatePicker
                    showTimeSelect
                    disabledKeyboardNavigation
                    name="StartDate"
                    selected={sdate}          
                    className="customInput"
                    popperProps={{
                      positionFixed: true // use this to make the popper position: fixed
                    }}
                    dateFormat="YYYY-MM-dd hh:mm aa"
                    autoComplete="off"        
                    onChange={(sdate) => setSDate(new Date(sdate))}
                  />
            
                  <label htmlFor="CompleteDate" className="form-label">Complete Date</label>
                  <DatePicker
                    showTimeSelect
                    disabledKeyboardNavigation
                    name="CompleteDate"
                    selected={cdate}          
                    className="customInput"
                    popperProps={{
                      positionFixed: true // use this to make the popper position: fixed
                    }}
                    dateFormat="YYYY-MM-dd hh:mm aa"
                    autoComplete="off"        
                    onChange={(cdate)=>setCDate(new Date(cdate))}
                  />
                </FormControl>
              </Item>
          </Box>
          <Box className="outerbox"  sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, 2fr)', gap: 2 ,m:1}}>
            <Item>
              <FormControl fullWidth>
              <label htmlFor="WorkType" className="form-label">Work Type*</label>
              <Select
                name="WorkType"
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={data.WorkType}
                onChange={handleChange}
                size="small"
                autoWidth
                required
                displayEmpty
              >
                  <MenuItem value=""><em>Select Work Type</em></MenuItem>
                  <MenuItem value="New Work">New Work</MenuItem>
                  <MenuItem value="Electrical Maintenance">Electrical Maintenance</MenuItem>
                  <MenuItem value="Machine Maintenance">Machine Maintenance</MenuItem>
              </Select>

              <label htmlFor="WorkSubType" className="form-label">Work Sub Type</label>
              <Select
                size="small"
                name="WorkSubType"
                value={data.WorkSubType}
                onChange={handleChange}
                displayEmpty
                disabled={getWorkSubTypeOptions(data.WorkType).length === 0}
              >
                <MenuItem value=""><em>Select Work Sub Type</em></MenuItem>
                {getWorkSubTypeOptions(data.WorkType).map((option) => (
                  <MenuItem key={option} value={option}>{option}</MenuItem>
                ))}
              </Select>

            <label htmlFor="Department" className="form-label">Department*</label>
            <Select
                        name="Department"
                        value={data.Department}
                        onChange={handleChange}
                        required
                    >
                      <MenuItem value=""><em>Select department</em></MenuItem>
                        {departments.map((department, index) => (
                            <MenuItem key={index} value={department}>{department}</MenuItem>
                        ))}
                    </Select>

                    <label htmlFor="Machine" className="form-label">Machine*</label>
                    <Select
                        name="Machine"
                        value={data.Machine}
                        onChange={handleChange}
                        required
                    >
                      <MenuItem value=""><em>Select machine</em></MenuItem>
                        {(machines[data.Department] || []).map((machine, index) => (
                            <MenuItem key={index} value={machine}>{machine}</MenuItem>
                        ))}
                    </Select>
              {errors.Machine &&
                            <span style={{ color: 'red'}} className="error-message">
                                {errors.Machine}
                            </span>
              }
            </FormControl>  
            </Item>
            <Item>
                <label htmlFor="Description" className="form-label">
                  Description 
                </label>
                <textarea
                  name="MainDesc"
                  cols="30"
                  rows="2"
                  className="form-control light"
                  value={data.MainDesc}
                  onChange={handleChange}
                  style={{ borderColor: colors.grey[700],border: '1px solid'
                    }}
                />
              <label htmlFor="Comments" className="form-label">
                Comments 
                </label>
                <textarea
                  name="Comments"
                  cols="30"
                  rows="3"
                  className="form-control"
                  value={data.Comments}
                  style={{ borderColor: colors.grey[100]
                    , border:'1px solid'}}
                  onChange={handleChange}
                />
            </Item>
          </Box>
        
        <Box sx={{ display: 'flex',  justifyContent: 'center', padding:'3px'}}>
          <Stack spacing={2} direction="row">
            
            <label htmlFor="SlipNo" className="form-label">Slip No*</label>
            <TextField  required size="small" name="SlipNo" onChange={handleChange} variant="outlined" />
            {errors.SlipNo &&
                            <span style={{ color: 'red'}} className="error-message">
                                {errors.SlipNo}
                            </span>
            }
            <Divider/><Divider/><Divider/> 
              
            <label htmlFor="Remarks" className="form-label">Remarks</label>
            <TextField   size="small" name="Remarks" onChange={handleChange} variant="outlined" />        
            <Divider/><Divider/><Divider/> 
              
            <label   htmlFor="AssignedTo" className="form-label">Assigned To*</label>        
            <TextField required size="small" name="AssignedTo" onChange={handleChange} variant="outlined" />
            <Divider/><Divider/><Divider/> 
            
          </Stack>
          </Box>
          <Divider style={{ marginTop: '20px' }} />    
          <Grid item xs={12} sx={{ marginTop:"20px", display: 'flex', justifyContent: 'center' }}>
            <Button size="large" onClick={() => [onClose(), handleClose()]} color="secondary" sx={{ marginRight: 2,':hover': {
                    bgcolor: '#4863C0', // theme.palette.primary.main
                    color: 'white',
                  }, }}>
              Cancel
            </Button>
            <Button size="large" onClick={handleSubmitOnDB}  sx={{backgroundColor:'#4863A0',':hover': {
                    bgcolor: '#4863C0', // theme.palette.primary.main
                    color: 'white',
                  },}} variant="contained">
              Save
            </Button>            
          </Grid>
          {/* <Box display="flex" sx={{marginTop:"20px"}} justifyContent="space-between">
            <Button
              variant="contained" 
              type="submit"   
              sx={{backgroundColor:'#4863A0'}} 
              onClick={handleSubmitOnDB}
            >
              Save
            </Button>
            <Button
              variant="outlined"
              sx={{
                ':hover': {
                    bgcolor: '#4863C0', // theme.palette.primary.main
                    color: 'white',
                  },
              }} 
              onClick={() => [onClose(), handleClose()]}
            >
            Cancel
            </Button>
          </Box> */}
        </form>
      </div>    
    </Drawer>
    
  ): ""
  
};

export default Add;